<script>

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

import UserCircle from '@/ui/UserCircle'
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'
import LoadingScreen from '@/components/General/LoadingScreen'
import CheckboxToggle from '@/components/General/CheckboxToggle'
import Alert from '@/components/General/Alert'

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

import CampaignEdit from '@/components/CustomMailing/MailingCampaigns/CampaignEdit.vue'
import CampaignDelete from '@/components/CustomMailing/MailingCampaigns/CampaignDelete.vue'
import CampaignSend from '@/components/CustomMailing/MailingCampaigns/CampaignSend.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getCampaigns, unlockCampaign, changeStateCampaign, getCampaignTypeOptions } from '@/services/mailing/serviceCampaign';


export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Campaigns',
	mixins: [ MixinGeneralFunct ],
	components: {
		//"font-awesome-icon":FontAwesomeIcon
		CampaignEdit,CampaignDelete,CampaignSend
		,UserCircle
		,MyPagination,MyCountRecords
		,LoadingScreen
		,CheckboxToggle
		,Alert
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			prefix:'',
		
            
            metaData:[],
            
            isLoading:true,

            menuItems:[],
            actLangs:[],
            
            helpboxData: [],
            
            totalCount:0,
            dataList:[],
            selectedFilterText:'',
            
            selectedType:'',
            optionsTypes:[],

            selectedCampaignId:'',

            countPages:0,

			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
			
			checkAllItems:false,
		
			showFilter:false,
			filterExtended:true,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',

			modalEdit:{},
			modalEditId:'',

			modalSend:{},
			modalSendId:'',


		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;
		this.modalSendId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
				
		onLoadPage:function(){

			this.isLoading=true

			getCampaigns({filterText: this.selectedFilterText, filterType: this.selectedType, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;
					
					//oznacenie poloziek cez strankovac
					for(let i = 0; i < this.dataList.length; i++){
						if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
							this.dataList[i].selectedId=true;
						}
					}
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});

			getCampaignTypeOptions().then(response => {
				this.optionsTypes=response.optionsTypes;
			});

		},
		
				
		//odomknutie zaznamu
		onUnLock:function(campaignId){
			this.cSession();
			this.isLoading=true
			unlockCampaign(campaignId).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
		
		
		
		
		
		//(od)oznacenie vsetkych poloziek
		onCheckAllItems:function(){
			if(this.checkAllItems){
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=true;
					if(this.allSelectedItems.indexOf(this.dataList[i].id)==-1){
						this.selectedItemStore.addSelectedItems(this.dataList[i].id);
					}
				}
			}else{
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=false;
					var indexToRemove = this.allSelectedItems.indexOf(this.dataList[i].id);
					if(indexToRemove>=0){
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
		},
		
		//oznacenie jednej polozky
		onCheckItem:function(index,id){
			if(this.dataList[index].selectedId==true){
				this.selectedItemStore.addSelectedItems(id);
			}else{
				var indexToRemove = this.allSelectedItems.indexOf(id);
				this.selectedItemStore.deleteSelectedItems(indexToRemove);
			}
		},

		//zrusenie vyberu
		onResetSelected:function(){
			for(let i = this.allSelectedItems.length; i>=0 ;i--){
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if(indexToRemove>=0){
					var index = this.dataList.findIndex(item => item.id==this.allSelectedItems[i]); 
					if(index>=0){
						this.dataList[index].selectedId=false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		

		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box  editacia
		loadModalFormCampaignEdit:function(recordID){
			this.cSession();
			console.log(recordID)
			this.selectedCampaignId=String(recordID);
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box  delete
		loadModalFormCampaignDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedCampaignId=String(recordID);
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},

		//modal box  send campaign
		loadModalFormCampaignSend:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedCampaignId=String(recordID);
			this.modalSend = new bootstrap.Modal(document.getElementById(this.modalSendId), {backdrop:'static'})
			this.modalSend.show();
		},
		
		

		
		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedCampaignId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},
		

		//zmena stavu
		onChangeState:function(e){
			this.cSession();			
			this.isLoading=true
			changeStateCampaign({recordId:e.id,state:e.state}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

	},	
	
			
	watch: {
		'auth.campaignsList': function () {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	<div id="version" class="version"><p>{{metaData.version}}</p></div>

		<div v-if="metaData.modulAccess" > 
					
            <div class="row">
                <div class="col-12">
                                    
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCustomMailing.Campaigns') }}</h5>	 
						</div> 
						
						<div class="col-6 right">
							<button type="button" :disabled="!auth.campaignsNew" v-on:click="loadModalFormCampaignEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
						</div> 
					</div>

					<!-- filters basic -->
					<div class="row">
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i> 
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
					</div>
					

					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-4">
					
							<select v-model='selectedType' class="form-control form-control-sm" v-on:change="onLoadPage()">
								<option value="">{{ $t('msgCore.selectType') }}</option>
								<option v-for="(options) in optionsTypes" :value="options.value" :key="options.value">{{ options.title }}</option>
							</select>
							
						</div>					
					</div>
                        
                    
                </div>
            </div>	

            
            <!-- zakladny zoznam -->
            <div v-if="totalCount>0">
            
                    <div class="row">
                        <div class="col-12">
        
                            <div class="table-responsive">
                                <table class="table table-hover table-sm">
                                
                                    <thead>
                                        <tr>
                                            <th class="orderBy" v-on:click="sort('id')" :class="{ active: isActive('id'), asc: isAsc('id'), desc: isDesc('id')}">id</th>
                                        
											<th width="10" class="align-middle"><div class="form-check"><label class="form-check-label"><input v-model="checkAllItems" v-on:change="onCheckAllItems()" class="form-check-input" type="checkbox"><span class="form-check-sign"><span class="check"></span></span></label></div></th>
                                        
                                            <th>
                                                {{$t('msgCore.Action')}}
                                            </th>
                                            
											<th colspan="2">{{$t('msgCore.State')}}</th>
                                            
                                           
                                            
                                            <th>{{$t('msgCore.Title')}}</th>
                                            
                                          
                                            <th>{{$t('msgCore.Type')}}</th>

											<th>{{$t('msgCustomMailing.Template')}}</th>
                                            
                                           
                                            
                                            <th>{{$t('msgCore.Created')}}</th>
                                            
                                            <th>{{$t('msgCore.Modified')}}</th>
                                            
                                           
                                            
                                            <th>{{$t('msgCore.AccessLevel')}}</th>									
                                        </tr>
                                    </thead>
                                    
                                    
                                    <tr v-for="(basicObj, index) in dataList" :key="basicObj">
                                    
                                        <td>{{ basicObj.id }}</td>
                                        
                                        <td class="align-middle">
                                            <div class="form-check">
                                                <label class="form-check-label">
                                                <input v-model.number='basicObj.selectedId' class="form-check-input" type="checkbox" v-on:change="onCheckItem(index,basicObj.id);">
                                                <span class="form-check-sign"><span class="check"></span></span>
                                                </label>
                                            </div>	
                                        </td>
                                    
                                        <td>
                                            <div class="input-group">	
                                                
                                                <button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.campaignsUnlock" v-on:click="onUnLock(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>
                                                
                                                <div class="btn-group">				
                                                    <button type="button" :disabled="!auth.campaignsEdit" v-on:click="loadModalFormCampaignEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" class="btn btn-secondary btn-sm"><i class="smire-icon fas fa-edit"></i></button>
                                                    
                                                    <button type="button" :disabled="!auth.campaignsDelete" v-on:click="loadModalFormCampaignDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-trash-alt"></i></button>

													<button type="button" :disabled="!auth.campaignsSend" v-on:click="loadModalFormCampaignSend(basicObj.id)" :title="$t('msgCore.Send')" class="btn btn-info btn-sm"><i class="smire-icon fas fa-paper-plane"></i></button>                                                      
                                                </div>	
                                                
                                                
                                            </div>	
                                        </td>
                                        
                                        <td  :title="$t('msgCore.' + basicObj.state_name)">
											<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2}" ></i>
										</td>	

										
										<td>
											<CheckboxToggle :key="basicObj.id" :isDisabled="(!auth.campaignsChangeState)" :data="basicObj" @onClick="onChangeState"></CheckboxToggle>
										</td>
                                        
                                      
                                        
                                        <td>{{ basicObj.name }}</td>
                                        
                                                                              
                                        <td>{{ basicObj.typeName }}</td>
                                        
                                        <td>{{ basicObj.templateName }}</td>													
                                        
										<td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
                                        
                                        <td>{{ basicObj.access_name }}</td>
                                        
                                        
                                    </tr>
                                        

                                
                                </table>	
                            </div>		
                        
                        </div>
                    </div>

                    <div class="row row-pagination">
						<div class="col-6 col-md-3 col-lg-2">
							<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
						</div>
						
						<div class="col-6 col-md-3 col-lg-2 box-flex">
							<span>Počet: {{totalCount}} <button v-if="allSelectedItems.length>0" type="button" @click="onResetSelected()" class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i class="fas fa-times"></i></button></span>
						</div>
						
						<div class="col-12 col-md-6 col-lg-8">	
							<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
						</div>
					</div>
                    
                
            </div>	
            
            <div v-else class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>							
            </div>
            
        </div>	
        
        <div v-else class="container-fluid">
            <div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
            </div>
        </div>
	
		<CampaignEdit :auth="auth" :secData="secData" :campaignId="selectedCampaignId" @changeRecord="onChangeItem" :modalObject="modalEdit" :modalId="modalEditId"></CampaignEdit>
		<CampaignDelete :auth="auth" :secData="secData" :campaignId="selectedCampaignId" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></CampaignDelete>
		<CampaignSend :auth="auth" :secData="secData" :campaignId="selectedCampaignId" @changeRecord="onChangeItem" :modalObject="modalSend" :modalId="modalSendId"></CampaignSend>
		
	</div>
</template>


